import { Box, Typography } from "@mui/material";
import { EditLinkButton } from "Components/Shared/Buttons/EditLinkButton";
import type { ReactNode } from "react";

type Props = {
  title?: string;
  onEdit?: () => void;
  withTopMargin?: boolean;
  children: ReactNode;
};

export const ValuesBox = ({
  children,
  onEdit,
  title,
  withTopMargin,
}: Props) => {
  return (
    <Box display="grid" rowGap={3} marginTop={withTopMargin ? 6 : undefined}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {!!title && (
          <Typography fontSize={16} fontWeight={600} textTransform="uppercase">
            {title}
          </Typography>
        )}
        {!!onEdit && <EditLinkButton onClick={onEdit} />}
      </Box>
      {children}
    </Box>
  );
};
